import React, { FC, useState } from "react";
import { Button } from "../../components/Modal";
import SelectInputBox from "../../components/Modal/SelectInputBox";
import styles from "../../styles/Template.module.css";
import InputField from "../../components/Modal/InputField";
import CheckboxInput from "../../components/Modal/CheckBoxInput";
import { FormData, Option } from "../../hooks/rtmTemplate/index.type";
import { QuestionWithErrors } from "./MultipleCategorySection";

interface AnswerSectionProps {
  formData?: FormData;
  currentQuestion: QuestionWithErrors;
  setCurrentQuestion: React.Dispatch<React.SetStateAction<QuestionWithErrors>>;
  setFormData?: React.Dispatch<React.SetStateAction<FormData>>;
  selectedAnswerType: string;
  setSelectedAnswerType: React.Dispatch<React.SetStateAction<string>>;
  isEditing?: boolean
handleToggleEditState: (state: boolean) => void;
}

const AnswerSection: FC<AnswerSectionProps> = ({
  currentQuestion,
  setCurrentQuestion,
  setSelectedAnswerType,
  formData,
  isEditing,
  handleToggleEditState
}) => {
  const [options, setOptions] = useState<Option[]>([
    { key: "", name: "", textboxRequired: "no" as const },
  ]);
  const [focusedIndex, setFocusedIndex] = React.useState<number | null>(null);

  const [scaleValues, setScaleValues] = useState({
    startValue: "",
    startLabel: "",
    endValue: "",
    endLabel: "",
  });

  const lastInputRef = React.useRef<HTMLInputElement | null>(null);
  const containerRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (lastInputRef.current) {
      lastInputRef.current.focus();
      lastInputRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [options.length]);

  React.useEffect(() => {
    if (currentQuestion.option && currentQuestion.option.length) {
      setOptions(currentQuestion.option);
    }
  }, [currentQuestion.option]);

  React.useEffect(() => {
  if (
    currentQuestion.scale &&
    scaleValues.startValue === "" && 
    scaleValues.endValue === ""
  ) {
    setScaleValues({
      startValue: currentQuestion.scale.min.key,
      startLabel: currentQuestion.scale.min.name,
      endValue: currentQuestion.scale.max.key,
      endLabel: currentQuestion.scale.max.name,
    });
  }
}, [currentQuestion.scale]);



  const handleAnswerTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newAnswerType = e.target.value;
    setSelectedAnswerType(newAnswerType);
    let updatedOptions: Option[] = [];
    if (
      newAnswerType === "single_option" ||
      newAnswerType === "multiple_option"
    ) {
      updatedOptions = [{ key: "", name: "", textboxRequired: "no" }];
    }
    if (newAnswerType === "textarea") {
      updatedOptions = [
        { key: "textarea", name: "textarea", textboxRequired: "no" },
      ];
    } else if (newAnswerType === "scale") {
      setScaleValues({
        startValue: "",
        startLabel: "",
        endValue: "",
        endLabel: "",
      });
      updatedOptions = [
        { key: "", name: "", textboxRequired: "no" },
        { key: "", name: "", textboxRequired: "no" },
      ];
    }

    setOptions(updatedOptions);

    setCurrentQuestion((prev) => ({
      ...prev,
      answerType: newAnswerType,
      option: updatedOptions,
      errors: { ...prev.errors, option: "", answerType: "" },
    }));
  };
  const handleAddMore = () => {
    const hasEmptyLabel = options.some((option) => option.name.trim() === "");

    if (hasEmptyLabel) {
      setCurrentQuestion((prev) => ({
        ...prev,
        errors: {
          ...prev.errors,
          option: "Please enter the label",
        },
      }));
      return;
    }

    // Clear previous error and add new option
    const updated = [
      ...options,
      { key: "", name: "", textboxRequired: "no" as const },
    ];
    setOptions(updated);
    setCurrentQuestion((prev) => ({
      ...prev,
      option: updated,
      errors: { ...prev.errors, option: "" },
    }));
  };

 
  //   index: number,
  //   field: "key" | "name",
  //   val: string
  // ) => {
  //   const updated = [...options];
  //   updated[index][field] = val;

  //   if (field === "name") {
  //     updated[index].key = val
  //       .trim()
  //       .toLowerCase()
  //       .replace(/\s+/g, "_")
  //       .replace(/[^a-z0-9_]/g, "");
  //   }

  //   setOptions(updated);

  //   setCurrentQuestion((prev) => ({
  //     ...prev,
  //     option: updated,
  //     errors: {
  //       ...prev.errors,
  //       option: "", 
  //     },
  //   }));
  // };

const handleOptionChange = (
  index: number,
  field: "key" | "name",
  val: string
) => {
  const updated = options.map((opt, i) =>
    i === index ? { ...opt, [field]: val } : opt
  );

  if (field === "name") {
    updated[index] = {
      ...updated[index],
      key: val
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[^a-z0-9_]/g, "")
    };
  }

  setOptions(updated);

  setCurrentQuestion((prev) => ({
    ...prev,
    option: updated,
    errors: {
      ...prev.errors,
      option: "",
    },
  }));
};


  const toggleTextbox = (index: number) => {
    const updated = [...options];
    updated[index].textboxRequired =
      updated[index].textboxRequired === "yes" ? "no" : "yes";
    setOptions(updated);
    setCurrentQuestion((prev) => ({
      ...prev,
      option: updated,
      errors: { ...prev.errors, option: "" },
    }));
  };




//  const handleScaleChange = (field: string, value: string) => {
//   const updatedScale = { ...scaleValues, [field]: value };
//   setScaleValues(updatedScale);

//   const { startValue, endValue, startLabel, endLabel } = updatedScale;

//   const updatedScaleObject = {
//     min: {
//       key: startValue,
//       name: startLabel,
//       textboxRequired: "no" as const,
//     },
//     max: {
//       key: endValue,
//       name: endLabel,
//       textboxRequired: "no" as const,
//     },
//   };

//   const isInvalidFormat = (val: string) =>
//     val !== "" && !/^\d*$/.test(val); 

//   const scaleOptionErrors = [
//     { key: "", name: "" },
//     { key: "", name: "" },
//   ];

//   if (field === "startValue" || field === "endValue") {
//     if (isInvalidFormat(startValue)) {
//       scaleOptionErrors[0].key = "Start value must be a positive number";
//     }

//     if (isInvalidFormat(endValue)) {
//       scaleOptionErrors[1].key = "End value must be a positive number";
//     }

//     const startNum = Number(startValue);
//     const endNum = Number(endValue);
//     const startValid = startValue !== "" && !isInvalidFormat(startValue);
//     const endValid = endValue !== "" && !isInvalidFormat(endValue);

//     if (startValid && endValid) {
//       if (startNum < 0) {
//         scaleOptionErrors[0].key = "Start value cannot be less than 0";
//       } else if (endNum > 10) {
//         scaleOptionErrors[1].key = "End value cannot be more than 10";
//       } else if (startNum >= endNum) {
//         scaleOptionErrors[0].key = "Start value must be less than end value";
//         scaleOptionErrors[1].key = "End value must be greater than start value";
//       }
//     }
//   }

//   setCurrentQuestion((prev) => ({
//     ...prev,
//     scale: updatedScaleObject,
//     errors: {
//       ...prev.errors,
//       scaleOptionErrors,
//     },
//   }));
// };


const handleScaleChange = (field: string, value: string) => {
  const updatedScale = { ...scaleValues, [field]: value };
  setScaleValues(updatedScale);

  const { startValue, endValue, startLabel, endLabel } = updatedScale;

  const updatedScaleObject = {
    min: {
      key: startValue,
      name: startLabel,
      textboxRequired: "no" as const,
    },
    max: {
      key: endValue,
      name: endLabel,
      textboxRequired: "no" as const,
    },
  };

  const isInvalidFormat = (val: string) =>
    val !== "" && !/^\d+$/.test(val); // Only allow positive integers

  // Default errors
  const scaleOptionErrors = [
    { key: "", name: "" },
    { key: "", name: "" },
  ];

  const startNum = Number(startValue);
  const endNum = Number(endValue);

  if (field === "startValue") {
    if (isInvalidFormat(startValue)) {
      scaleOptionErrors[0].key = "Start value must be a positive number";
    } else if (startNum < 0) {
      scaleOptionErrors[0].key = "Start value cannot be less than 0";
    } else if (!isInvalidFormat(endValue) && startNum >= endNum) {
      scaleOptionErrors[0].key = "Start value must be less than end value";
    }
  }

  if (field === "endValue") {
    if (isInvalidFormat(endValue)) {
      scaleOptionErrors[1].key = "End value must be a positive number";
    } else if (endNum > 10) {
      scaleOptionErrors[1].key = "End value cannot be more than 10";
    } else if (!isInvalidFormat(startValue) && startNum >= endNum) {
      scaleOptionErrors[1].key = "End value must be greater than start value";
    }
  }

  setCurrentQuestion((prev) => ({
    ...prev,
    scale: updatedScaleObject,
    errors: {
      ...prev.errors,
      scaleOptionErrors,
    },
  }));
};

  const handleDeleteOption = (index: number) => {
    const updated = options.filter((_, i) => i !== index);
    setOptions(updated);
    setCurrentQuestion((prev) => ({
      ...prev,
      option: updated,
    }));
  };

  return (
    <div className={styles.answer_section}>
      <div className={styles.select_answer}>
        <span>Answer Type:</span>
        <SelectInputBox
          label=""
          value={currentQuestion.answerType}
          onChange={handleAnswerTypeChange}
          className={styles.select_answer_input}
          containerClass={styles.answer_type_dropdown}
          errorMessage={currentQuestion.errors?.answerType}
          errorClass={styles.error}
          disable={isEditing ? true : false}
        >
          <option value="">Answer Type</option>
          <option value="single_option">Single Option</option>
          <option value="multiple_option">Multiple Option</option>
          <option value="scale">Scale</option>
          {/* <option value="textarea">Text Area</option> */}
        </SelectInputBox>

        {(currentQuestion.answerType === "single_option" ||
          currentQuestion.answerType === "multiple_option") && (
            <Button
              span={false}
              label="Add More"
              icon="icon-add"
              customClass={styles.add_btn}
              iconStyle={{ width: "2rem", height: "1.5rem" }}
              onClick={handleAddMore}
            />
          )}
      </div>

      {(currentQuestion.answerType === "single_option" ||
        currentQuestion.answerType === "multiple_option") && (
          <div className={styles.answer_container} ref={containerRef}>
            {options.map((option, index) => (
              <span
                key={index}
                style={{ display: "flex", gap: "0rem" }}
              >
                <div className={styles.answer_container_section} >
                  <InputField
                    label={index === 0 ? "Value" : ""}
                    value={String(index + 1)}
                    className={styles.answer_option_inputField}
                    containerClass={styles.answer_option}
                    style={{ gap: index === 0 ? "1px" : "4px" }}
                    inputCustomStyle={{
                      gap: index === 0 ? "0px" : "0px",
                    }}
                    labelClass={styles.answer_label}
                    readOnly={true}
                  />
                  <InputField
                    label={index === 0 ? "Label" : ""}
                    value={option.name}
                    onChange={(e) =>
                      handleOptionChange(index, "name", e.target.value)
                    }
                    containerClass={styles.answer_option}
                    style={{ gap: index === 0 ? "1px" : "4px" }}
                    className={styles.answer_option_inputField}
                    inputCustomStyle={{
                      gap: index === 0 ? "0px" : "0px",
                    }}
                    labelClass={styles.answer_label}
                    errorMessage={
                      option.name.trim() === "" && currentQuestion.errors?.option
                        ? currentQuestion.errors.option
                        : ""
                    }
                    errorClass={`${styles.error} ${styles.input_error}`}
                    inputRef={index === options.length - 1 ? lastInputRef : null}
                  // onfocus={() => setFocusedIndex(index)}
                  // containerClass={`${styles.answer_option} ${focusedIndex === index ? styles.focused_input : ""}`}
                  />
                </div>

                {formData?.type === "intakeForm" && (
                  <div style={{ marginTop: index === 0 ? "3rem" : "0.8rem" }}>
                    <CheckboxInput
                      label="Has Details"
                      checked={option.textboxRequired === "yes"}
                      onChange={() => toggleTextbox(index)}
                      containerStyle={{ marginLeft: "18px", width: "100%" }}
                      labelClass={styles.checkbox_label}
                    />
                  </div>
                )}
                {options.length >= 1 && !option.key && (
                  <button className={styles.icon_button}>
                    <svg
                      onClick={() => handleDeleteOption(index)}
                      style={{
                        marginTop: index === 0 ? "1rem" : "-8rem",
                        marginLeft: "2.4rem",
                        cursor: "pointer",
                      }}
                      viewBox="0 0 14 16"
                    >
                      <path d="M4.225 0.553125L4 1H1C0.446875 1 0 1.44687 0 2C0 2.55312 0.446875 3 1 3H13C13.5531 3 14 2.55312 14 2C14 1.44687 13.5531 1 13 1H10L9.775 0.553125C9.60625 0.2125 9.25938 0 8.88125 0H5.11875C4.74062 0 4.39375 0.2125 4.225 0.553125ZM13 4H1L1.6625 14.5938C1.7125 15.3844 2.36875 16 3.15937 16H10.8406C11.6312 16 12.2875 15.3844 12.3375 14.5938L13 4Z" />
                    </svg>
                  </button>
                )}

              </span>
            ))}
          </div>
        )}

      {currentQuestion.answerType === "scale" && (
        <div className={styles.scale_container}>
          <div style={{ display: "flex", marginBottom: "1rem" }}>
            <div
              style={{ display: "flex", flexDirection: "column", width: "40%" }}
            >
              <div className={styles.scale_label_container}>
                <span>Start Value:</span>
                <InputField
                  value={scaleValues.startValue}
                  onChange={(e) =>
                    handleScaleChange("startValue", e.target.value)
                  }
                  containerClass={styles.answer_scale}
                  className={styles.gap}
                  disabled={isEditing}
                />
              </div>
              <span className={styles.error}>
                {currentQuestion?.errors?.scaleOptionErrors?.[0]?.key}
              </span>
            </div>
            <div className={styles.scale_sub_container}>
              <span>Label</span>
              <InputField
                value={scaleValues.startLabel}
                onChange={(e) =>
                  handleScaleChange("startLabel", e.target.value)
                }
                containerClass={styles.scale_label_input}
                className={styles.gap}
                errorMessage={
                  currentQuestion?.errors?.scaleOptionErrors?.[0]?.name
                }
                errorClass={styles.error}

              />
            </div>
          </div>

          <div style={{ display: "flex", justifyItems: "center" }}>
            <div
              style={{ display: "flex", flexDirection: "column", width: "40%" }}
            >
              <div className={styles.scale_label_container}>
                <span>End Value:</span>
                <InputField
                  value={scaleValues.endValue}
                  onChange={(e) =>
                    handleScaleChange("endValue", e.target.value)
                  }
                  containerClass={styles.answer_scale}
                  className={styles.gap}
                  // errorMessage={
                  //   currentQuestion?.errors?.scaleOptionErrors?.[1]?.key
                  // }
                  errorClass={styles.error}
                    disabled={isEditing}
                />
              </div>
              <span className={styles.error}>
                {currentQuestion?.errors?.scaleOptionErrors?.[1]?.key}
              </span>
            </div>
            <div className={styles.scale_sub_container}>
              <span>Label</span>
              <InputField
                value={scaleValues.endLabel}
                onChange={(e) => handleScaleChange("endLabel", e.target.value)}
                containerClass={styles.scale_label_input}
                className={styles.gap}
                errorMessage={
                  currentQuestion?.errors?.scaleOptionErrors?.[1]?.name
                }
                errorClass={styles.error}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnswerSection;
